export default {
    methods: {
        comprobarButacasLFP(filas) {
            var valido = true;
            
            for (var filaKey in filas) {
                var asientos = filas[filaKey].asientos;

                for (var asientoKey in asientos) {
                    var asiento = asientos[asientoKey];
                    var asientoIndex = parseInt(asientoKey);

                    if (asiento.seleccionado && valido) {
                        var totalAsientos = Object.keys(asientos).length;

                        if (asientoIndex > 1 && asientoIndex < totalAsientos - 1) {
                            if (
                                asientos[asientoIndex - 1] &&
                                asientos[asientoIndex - 2] &&
                                asientos[asientoIndex - 1].seleccionado == 0 &&
                                asientos[asientoIndex - 1].ocupado == 0 &&
                                asientos[asientoIndex - 2].ocupado == 1
                            ) {
                                valido = false;
                            }

                            if (asientos[asientoIndex + 1] && asientos[asientoIndex + 2]) {
                                if (
                                    asientos[asientoIndex + 1].seleccionado == 0 &&
                                    asientos[asientoIndex + 1].ocupado == 0 &&
                                    asientos[asientoIndex + 2].ocupado == 1
                                ) {
                                    valido = false;
                                }
                            }
                        }

                        if (
                            asientoIndex > 1 &&
                            asientoIndex < totalAsientos - 1 &&
                            asientos[asientoIndex - 1].ocupado == 1 &&
                            asientos[asientoIndex + 1].ocupado == 1
                        ) {
                            valido = true;
                        }

                        if (asientoIndex == 0) {
                            if (
                                asientos[asientoIndex + 1].seleccionado == 0 &&
                                asientos[asientoIndex + 1].ocupado == 0 &&
                                asientos[asientoIndex + 2].ocupado == 1
                            ) {
                                valido = false;
                            }
                        }

                        if (asientoIndex == totalAsientos) {
                            if (
                                asientos[asientoIndex - 1].seleccionado == 0 &&
                                asientos[asientoIndex - 1].ocupado == 0 &&
                                asientos[asientoIndex - 2].ocupado == 1
                            ) {
                                valido = false;
                            }
                        }

                        if (
                            asientoIndex > 1 &&
                            asientoIndex < totalAsientos - 1 &&
                            asientos[asientoIndex - 1].seleccionado == 0 &&
                            asientos[asientoIndex - 2] &&
                            asientos[asientoIndex - 2].seleccionado == 1
                        ) {
                            valido = false;
                        }

                        if (
                            asientoIndex == 1 &&
                            asientos[asientoIndex - 1].ocupado == 0 &&
                            asientos[asientoIndex - 1].seleccionado == 0
                        ) {
                            valido = false;
                        }

                        if (
                            asientoIndex == totalAsientos - 1 &&
                            asientos[asientoIndex + 1] &&
                            asientos[asientoIndex + 1].ocupado == 0 &&
                            asientos[asientoIndex + 1].seleccionado == 0
                        ) {
                            valido = false;
                        }

                        if (
                            asientoIndex > 1 &&
                            asientoIndex < totalAsientos - 1 &&
                            asientos[asientoIndex + 1].ocupado == 1 &&
                            asientos[asientoIndex - 1].ocupado == 1
                        ) {
                            valido = true;
                        }
                    }
                }
            }

            return valido;
        },
    }
}
